<template>
	<div v-if="showImage" class="hero-container" v-resize.initial="handleResize">
		<slot name="above"></slot>
		<img ref="heroImage"
			:src="imageUrl"
			:alt="altText"
			class="no-highlight hero-image"
			@onLoad="loadImage"
			@onError="loadError" />
		<slot name="below"></slot>
	</div>
</template>

<script>
	import resize from 'vue-resize-directive';
	export default {
		directives: {
			resize,
		},
		props: {
			altText: {
				type: String,
				default: 'hero image',
			},
			imageUrl: {
				type: String,
				default: '',
			},
			useRatio: {
				type: Number,
				default: 1.1826484018,
			},
		},
		data() {
			return {
				showImage: true,
			};
		},
		methods: {
			loadImage() {},
			loadError() {
				this.showImage = false;
				console.error("failed to load image");
			},
			handleResize() {
				const $el = this.$el;
				const $image = this.$refs['heroImage'];
				const width = $el.clientWidth * (1/this.useRatio);
				$image.style.height = width + 'px';
			},
		},
	}
</script>

<style lang="scss">
	.hero-image {
		max-width: 100% !important;
		min-width: 100%;
		max-height: 33vh;
		object-fit: cover;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseHeroImage.vue